export function formatBillQueue(queueNo) {
  if (queueNo === null || queueNo === undefined || queueNo === "") {
    return "";
  }

  const number = Number(queueNo);
  if (!Number.isInteger(number) || number < 1) {
    return "";
  }

  return String(number).padStart(2, "0");
}
